import React from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SalonPublicThemeProvider } from '../../../context/SalonPublicThemeContext';
import {
  DEFAULT_SALON_PUBLIC_TEMPLATE_KEY,
  createSalonTemplateAppearance,
} from '../../../theme/salonPublicTemplates';
import SalonTemplateRenderer from '../salonPublicTemplates/SalonTemplateRenderer';


const SalonThemePreview = ({
  appearance,
  viewModel,
  direction = 'ltr',
  viewport = 'desktop',
  isLoading = false,
  isError = false,
}) => {
  const { t } = useTranslation();
  const resolvedAppearance = appearance || createSalonTemplateAppearance(
    DEFAULT_SALON_PUBLIC_TEMPLATE_KEY,
  );

  const keepLinksInert = (event) => {
    const link = event.target.closest?.('a');
    if (link && link.dataset.salonPreviewInteractive !== 'true') event.preventDefault();
  };

  return (
    <SalonPublicThemeProvider
      config={resolvedAppearance.theme}
      layoutConfig={resolvedAppearance.layout}
      templateKey={resolvedAppearance.template_key}
      direction={direction}
    >
      <Box
        data-testid="salon-theme-preview"
        data-template-key={resolvedAppearance.template_key}
        data-theme-primary={resolvedAppearance.theme.primary_color}
        data-theme-font={resolvedAppearance.theme.font_key}
        dir={direction}
        onClickCapture={keepLinksInert}
        sx={{ minHeight: '100%', minWidth: 0, width: '100%' }}
      >
        {(isLoading || isError) ? (
          <Stack spacing={1} sx={{ p: 1.5 }}>
            {isLoading ? (
              <Stack
                role="status"
                direction="row"
                spacing={1}
                alignItems="center"
              >
                <CircularProgress size={18} />
                <Typography variant="body2">
                  {t('salon_theme.preview.data_loading')}
                </Typography>
              </Stack>
            ) : null}
            {isError ? (
              <Alert severity="warning">
                {t('salon_theme.preview.data_error')}
              </Alert>
            ) : null}
          </Stack>
        ) : null}
        <SalonTemplateRenderer
          templateKey={resolvedAppearance.template_key}
          viewModel={viewModel || {}}
          mode="preview"
          viewport={viewport}
          direction={direction}
        />
      </Box>
    </SalonPublicThemeProvider>
  );
};

export default SalonThemePreview;
